/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";
import { ecommerceapiUrl, adminlimit, clientheaderconfig } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { showStatus, encodeValue, removeItem, showLoader, hideLoader, clientID, showAlert, checkingPermisson, showRecords, showSortingNew } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
const Parser = require("html-react-parser");
var module = "products";
var moduleName = "Products";

class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    const locState = this.props.location?.state;
    const pathname = this.props.location?.pathname || "";
    this.state = {
      companyID: companyID,
      path: pathname,
      totalRecords: 0,
      totalPage: 0,
      currentPage: locState?.currentPage || 1,
      listdata: [],
      loading: true,
      name: locState?.name || "",
      status: locState?.status || "",
      storeID: locState?.storeID || "",
      categoryID: locState?.categoryID || "",
      subcategoryID: locState?.subcategoryID || "",
      specialProduct: locState?.specialProduct || "",
      outletList: [],
      categoryList: [],
      subcategoryList: [],
      errorFile: false,
      errorComobFile: false,
      allowOutlet: cookie.load("clientAllowOutlet") ?? "",
      exportUrl: "",
      selectedItem: [],
      sortKey: locState?.sortKey || "",
      sortValue: locState?.sortValue || "",
      productSequenceList: [],
      productPriceList: [],
      checkall: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(this.state.currentPage);
    this.loadOutlet();
    this.loadCategory();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState(
        {
          listdata: nextProps.listdata,
          loading: false,
          totalRecords: nextProps.totalRecords,
          totalPage: nextProps.totalPages,
        },
        () => {
          const isAllAvailable = this.state.listdata.every((item) => this.state.selectedItem.includes(item._id));
          this.setState({ checkall: isAllAvailable });
        },
      );
    }
    if (this.props.location?.state !== nextProps.location?.state) {
      this.setState(
        {
          name: nextProps.location?.state?.name || "",
          status: nextProps.location?.state?.status || "",
          storeID: nextProps.location?.state?.storeID || "",
          categoryID: nextProps.location?.state?.categoryID || "",
          subcategoryID: nextProps.location?.state?.subcategoryID || "",
          specialProduct: nextProps.location?.state?.specialProduct || "",
          currentPage: nextProps.location?.state?.currentPage || 1,
        },
        () => {
          this.loadList(this.state.currentPage);
        },
      );
    }
  }
  loadOutlet() {
    var urlShringTxt = ecommerceapiUrl + "outlet/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  loadCategory() {
    var urlShringTxt = ecommerceapiUrl + "category/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          var result = res.data.result;
          this.setState({ categoryList: result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  loadsubcategory() {
    const categoryID = this.state.categoryID?.value ?? "";
    if (categoryID !== "") {
      var urlShringTxt = `${ecommerceapiUrl}subcategory/dropDownList?categoryID=${this.state.categoryID.value}`;
      axios
        .get(urlShringTxt, clientheaderconfig)
        .then((res) => {
          if (res.data.status === "ok") {
            var result = res.data.result;
            this.setState({ subcategoryList: result });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
          checkall: false,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "sort") {
      const valueSplit = value.split("|");
      this.setState({ sortKey: valueSplit[0], sortValue: valueSplit[1] }, () => {
        this.loadList(this.state.currentPage);
      });
    }
  };
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, "client", this.sateValChange, this.state.currentPage, "ecom");
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value }, () => {
      if (name === "categoryID") {
        this.setState({ subcategoryList: [] }, () => {
          this.loadsubcategory();
        });
      }
    });
  }

  searchList() {
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.storeID !== null && Object.keys(this.state.storeID).length > 0) {
      addParams += "&storeID=" + this.state.storeID.value;
    }
    if (this.state.categoryID !== null && Object.keys(this.state.categoryID).length > 0) {
      addParams += "&categoryID=" + this.state.categoryID.value;
    }
    if (this.state.subcategoryID !== null && Object.keys(this.state.subcategoryID).length > 0) {
      addParams += "&subcategoryID=" + this.state.subcategoryID.value;
    }

    if (this.state.status !== null && Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }
    if (this.state.specialProduct !== null && Object.keys(this.state.specialProduct).length > 0) {
      addParams += "&specialPorduct=" + this.state.specialProduct.value;
    }
    addParams += `&sortKey=${this.state.sortKey}&sortValue=${this.state.sortValue}`;

    var params = {
      params: "limit=" + adminlimit + "&offset=" + offset + addParams,
      url: ecommerceapiUrl + module,
      authType: "client",
    };
    var exportUrl = ecommerceapiUrl + module + "export?company_id=" + this.state.companyID + addParams;
    this.setState({ exportUrl: exportUrl });
    this.props.getListData(params);
  }
  resetSearch() {
    const locStates = this.props.location?.state || "";
    if (locStates) {
      this.props.navigate("/clientpanel/ecom-products");
    } else {
      this.setState(
        {
          loading: true,
          name: "",
          storeID: "",
          categoryID: "",
          subcategoryID: "",
          specialProduct: "",
          status: "",
          currentPage: 1,
        },
        () => {
          this.loadList(1);
        },
      );
    }
  }
  importProduct() {
    $("#productmodal").modal("toggle");
  }

  confirmimportProducts(type) {
    let formData = new FormData();
    const currentThis = this;
    let imagefile = "";
    if (type === "Simple Product") {
      imagefile = document.querySelector("#simple_file");
    } else if (type === "Combo Product") {
      imagefile = document.querySelector("#combo_file");
    }
    if (imagefile !== "") {
      if (imagefile.files.length === 0) {
        if (type === "Simple Product") {
          this.setState({ errorFile: true });
        } else if (type === "Combo Product") {
          this.setState({ errorComobFile: true });
        }

        return false;
      } else {
        if (type === "Simple Product") {
          this.setState({ errorFile: false });
        } else if (type === "Combo Product") {
          this.setState({ errorComobFile: false });
        }
      }

      if (type === "Simple Product") {
        showLoader("import_simple");
      } else if (type === "Combo Product") {
        showLoader("import_combo");
      }
      formData.append("import_file", imagefile.files[0]);
      formData.append("company_admin_id", clientID());
      formData.append("company_id", this.state.companyID);
      formData.append("type", type);
      axios
        .post(ecommerceapiUrl + module + "/import-simple", formData, {
          headers: {
            Authorization: `Bearer ${cookie.load("clientAccessToken")}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (res) {
          $("#productmodal").modal("toggle");
          if (type === "Simple Product") {
            hideLoader("import_simple");
          } else if (type === "Combo Product") {
            hideLoader("import_combo");
          }
          if (type === "Simple Product") {
            $("#simple_file").val("");
          } else if (type === "Combo Product") {
            $("#combo_file").val("");
          }
          var errMsg = res.data?.message;
          if (res.data.status === "success") {
            currentThis.setState({ loading: true }, () => {
              currentThis.loadList(1);
            });
            showAlert("Success", errMsg, "success", "No");
          } else {
            showAlert("Error", errMsg, "error", "No");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  showProductType(productType) {
    let result = "";
    if (productType === 1) {
      result = "Simple";
    } else if (productType === 2) {
      result = "Combo";
    } else if (productType === 3) {
      result = "Voucher";
    }
    return result;
  }
  selectItem(productID) {
    let selectedItem = this.state.selectedItem;
    if (selectedItem.indexOf(productID) >= 0) {
      selectedItem.splice(selectedItem.indexOf(productID), 1);
    } else {
      selectedItem.push(productID);
    }
    this.setState({ selectedItem });
  }
  applyChangeStatus(status, e) {
    e.preventDefault();
    let selectedItem = this.state.selectedItem;
    if (selectedItem.length > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to change the status of the selected item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, change it!",
        customClass: {
          confirmButton: "btn btn-primary me-3 waves-effect waves-light",
          cancelButton: "btn btn-label-secondary waves-effect",
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          try {
            const postData = {
              status,
              selectedItem: this.state.selectedItem.join(","),
            };
            return axios
              .post(`${ecommerceapiUrl}${module}/changebulkstatus`, postData, clientheaderconfig)
              .then((res) => {
                return res.data;
              })
              .catch((e) => {
                return e?.response?.data?.message || e.message;
              });
          } catch (err) {
            console.log(err);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        const value = result?.value ?? "";
        if (value !== "") {
          if (result.value.status === "ok") {
            Swal.fire({
              icon: "success",
              title: "Change Status!",
              text: result.value.message,
              customClass: {
                confirmButton: "btn btn-success waves-effect",
              },
            }).then(() => {
              this.loadList(this.state.currentPage);
              this.setState({ selectedItem: [] });
              // sateValChange("page", currentPage);
            });
          } else {
            Swal.fire({
              title: "Alert",
              text: result.value.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger waves-effect",
              },
            });
          }
        }
      });
    } else {
      showAlert("Error", "Please Select Any One Product", "error", "No");
    }
  }

  handleChangeSequence(productID, e) {
    const value = e.target.value;
    let productSequenceList = this.state.productSequenceList;
    const foundProduct = productSequenceList.findIndex((item) => item.productID === productID);
    if (foundProduct >= 0) {
      productSequenceList[foundProduct].value = value;
    } else {
      productSequenceList.push({ productID, value });
    }
    this.setState({ productSequenceList });
  }

  applyChangeSequence(e) {
    e.preventDefault();
    let productSequenceList = this.state.productSequenceList;
    if (productSequenceList.length > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to update sequence of the selected item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, change it!",
        customClass: {
          confirmButton: "btn btn-primary me-3 waves-effect waves-light",
          cancelButton: "btn btn-label-secondary waves-effect",
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          try {
            const postData = {
              selectedItem: JSON.stringify(productSequenceList),
            };
            return axios
              .post(`${ecommerceapiUrl}${module}/changebulksequence`, postData, clientheaderconfig)
              .then((res) => {
                return res.data;
              })
              .catch((e) => {
                return e?.response?.data?.message || e.message;
              });
          } catch (err) {
            console.log(err);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        const value = result?.value ?? "";
        if (value !== "") {
          if (result.value.status === "ok") {
            Swal.fire({
              icon: "success",
              title: "Sequence Update!",
              text: result.value.message,
              customClass: {
                confirmButton: "btn btn-success waves-effect",
              },
            }).then(() => {
              this.loadList(this.state.currentPage);
              this.setState({ productSequenceList: [] });
            });
          } else {
            Swal.fire({
              title: "Alert",
              text: result.value.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger waves-effect",
              },
            });
          }
        }
      });
    } else {
      showAlert("Error", "Please change the sequence of any one product.", "error", "No");
    }
  }

  handleChangePrice(productID, e) {
    const value = e.target.value;
    let productPriceList = this.state.productPriceList;
    const foundProduct = productPriceList.findIndex((item) => item.productID === productID);
    if (foundProduct >= 0) {
      productPriceList[foundProduct].value = value;
    } else {
      productPriceList.push({ productID, value });
    }
    this.setState({ productPriceList });
  }

  applyChangePrice(e) {
    e.preventDefault();
    let productPriceList = this.state.productPriceList;
    if (productPriceList.length > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to update sequence of the selected item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, change it!",
        customClass: {
          confirmButton: "btn btn-primary me-3 waves-effect waves-light",
          cancelButton: "btn btn-label-secondary waves-effect",
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          try {
            const postData = {
              selectedItem: JSON.stringify(productPriceList),
            };
            return axios
              .post(`${ecommerceapiUrl}${module}/changebulkprice`, postData, clientheaderconfig)
              .then((res) => {
                return res.data;
              })
              .catch((e) => {
                return e?.response?.data?.message || e.message;
              });
          } catch (err) {
            console.log(err);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        const value = result?.value ?? "";
        if (value !== "") {
          if (result.value.status === "ok") {
            Swal.fire({
              icon: "success",
              title: "Sequence Update!",
              text: result.value.message,
              customClass: {
                confirmButton: "btn btn-success waves-effect",
              },
            }).then(() => {
              this.loadList(this.state.currentPage);
              this.setState({ productSequenceList: [] });
            });
          } else {
            Swal.fire({
              title: "Alert",
              text: result.value.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger waves-effect",
              },
            });
          }
        }
      });
    } else {
      showAlert("Error", "Please change the sequence of any one product.", "error", "No");
    }
  }
  

  applyChangeSpecialProduct(specialProduct, type, e) {
    e.preventDefault();
    let selectedItem = this.state.selectedItem;
    if (selectedItem.length > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to ${type} ${specialProduct === "productFeatured" ? "Featured Dishes" : "New Dishes"} of the selected item?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, change it!",
        customClass: {
          confirmButton: "btn btn-primary me-3 waves-effect waves-light",
          cancelButton: "btn btn-label-secondary waves-effect",
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          try {
            const postData = {
              selectedItem: JSON.stringify(selectedItem),
              specialPorductType: specialProduct,
              addType: type,
            };
            return axios
              .post(`${ecommerceapiUrl}${module}/updatespecialPorduct`, postData, clientheaderconfig)
              .then((res) => {
                return res.data;
              })
              .catch((e) => {
                return e?.response?.data?.message || e.message;
              });
          } catch (err) {
            console.log(err);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        const value = result?.value ?? "";
        if (value !== "") {
          if (result.value.status === "ok") {
            Swal.fire({
              icon: "success",
              title: `${specialProduct === "productFeatured" ? "Featured Dishes" : "New Dishes"} Update!`,
              text: result.value.message,
              customClass: {
                confirmButton: "btn btn-success waves-effect",
              },
            }).then(() => {
              this.loadList(this.state.currentPage);
              this.setState({ selectedItem: [] });
            });
          } else {
            Swal.fire({
              title: "Alert",
              text: result.value.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger waves-effect",
              },
            });
          }
        }
      });
    } else {
      showAlert("Error", "Please select any one product.", "error", "No");
    }
  }

  removeSpecialProduct(productID, specialProduct, e) {
    e.preventDefault();
    if (productID !== "") {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to remove ${specialProduct === "productFeatured" ? "Featured Dishes" : "New Dishes"} of the selected item?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, change it!",
        customClass: {
          confirmButton: "btn btn-primary me-3 waves-effect waves-light",
          cancelButton: "btn btn-label-secondary waves-effect",
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          try {
            const postData = {
              selectedItem: JSON.stringify([productID]),
              specialPorductType: specialProduct,
              addType: "remove",
            };
            return axios
              .post(`${ecommerceapiUrl}${module}/updatespecialProduct`, postData, clientheaderconfig)
              .then((res) => {
                return res.data;
              })
              .catch((e) => {
                return e?.response?.data?.message || e.message;
              });
          } catch (err) {
            console.log(err);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        const value = result?.value ?? "";
        if (value !== "") {
          if (result.value.status === "ok") {
            Swal.fire({
              icon: "success",
              title: `${specialProduct === "productFeatured" ? "Featured Dishes" : "New Dishes"} Update!`,
              text: result.value.message,
              customClass: {
                confirmButton: "btn btn-success waves-effect",
              },
            }).then(() => {
              this.loadList(this.state.currentPage);
            });
          } else {
            Swal.fire({
              title: "Alert",
              text: result.value.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger waves-effect",
              },
            });
          }
        }
      });
    } else {
      showAlert("Error", "Please select any one product.", "error", "No");
    }
  }

  handleChangeCheckAll() {
    let ids = this.state.listdata.map((item) => item._id);
    const checkall_ = this.state.checkall;
    if (checkall_) {
      ids = [];
    }

    this.setState({ checkall: !this.state.checkall, selectedItem: ids });
  }

  editItem(editID, e) {
    const details = {
      name: this.state.name,
      status: this.state.status,
      storeID: this.state.storeID,
      categoryID: this.state.categoryID,
      subcategoryID: this.state.subcategoryID,
      currentPage: this.state.currentPage,
      sortKey: this.state.sortKey,
      sortValue: this.state.sortValue,
    };
    e.preventDefault();
    this.props.navigate(`${this.state.path}/edit/${editID}`, {
      state: details,
    });
  }

  changeStatus(productID, status, e) {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "You want change status this item!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      customClass: {
        confirmButton: "btn btn-primary me-3 waves-effect waves-light",
        cancelButton: "btn btn-label-secondary waves-effect",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        try {
          const postData = {
            status: status === "A" ? "I" : "A",
            selectedItem: productID,
          };
          return axios
            .post(`${ecommerceapiUrl}${module}/changebulkstatus`, postData, clientheaderconfig)
            .then((res) => {
              return res.data;
            })
            .catch((e) => {
              return e?.response?.data?.message || e.message;
            });
        } catch (err) {
          console.log(err);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      const value = result?.value ?? "";
      if (value !== "") {
        if (result.value.status === "ok") {
          Swal.fire({
            icon: "success",
            title: "Status Update!",
            text: result.value.message,
            customClass: {
              confirmButton: "btn btn-success waves-effect",
            },
          }).then(() => {
            this.loadList(this.state.currentPage);
          });
        } else {
          Swal.fire({
            title: "Alert",
            text: result.value.message,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger waves-effect",
            },
          });
        }
      }
    });
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"ecom-products"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-6 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  {checkingPermisson(["catalogs"], "add") && (
                    <div className="col-lg-6 col-md-6 text-end">
                      <Link to={this.state.path + "/add"}>
                        <button type="button" className="btn btn-outline-primary waves-effect">
                          Add New
                        </button>
                      </Link>
                      &nbsp;
                      <button type="button" className="btn btn-outline-primary waves-effect" onClick={this.importProduct.bind(this)}>
                        Import
                      </button>
                      &nbsp;
                      <a href={this.state.exportUrl}>
                        <button type="button" className="btn btn-outline-primary waves-effect">
                          Export
                        </button>
                      </a>
                    </div>
                  )}
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input type="text" className="form-control" name="name" onChange={this.handleChangeText} value={this.state.name} />
                      <label htmlFor="name">Search Keywords</label>
                    </div>
                  </div>
                  {this.state.allowOutlet === "" && (
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                        <Select value={this.state.storeID} onChange={this.handleSelectChange.bind(this, "storeID")} placeholder="Select Outlet" isClearable={true} options={this.state.outletList} />
                        <label className="select-box-label">Outlet</label>
                      </div>
                    </div>
                  )}
                  <div className={this.state.allowOutlet !== "" ? "col-md-4" : "col-md-3"}>
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.categoryID}
                        onChange={this.handleSelectChange.bind(this, "categoryID")}
                        placeholder="Select Category"
                        isClearable={true}
                        options={this.state.categoryList}
                      />
                      <label className="select-box-label">Category</label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.subcategoryID}
                        onChange={this.handleSelectChange.bind(this, "subcategoryID")}
                        placeholder="Select Sub Category"
                        isClearable={true}
                        options={this.state.subcategoryList}
                      />
                      <label className="select-box-label">Sub Category</label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.status}
                        onChange={this.handleSelectChange.bind(this, "status")}
                        placeholder="Select Status"
                        isClearable={true}
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                        ]}
                      />
                      <label className="select-box-label">Status</label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.specialProduct}
                        onChange={this.handleSelectChange.bind(this, "specialProduct")}
                        placeholder="Special Product"
                        isClearable={true}
                        options={[
                          { value: "productFeatured", label: "Featured Dishes" },
                          { value: "productNewDishes", label: "New Dishes" },
                        ]}
                      />
                      <label className="select-box-label">Special Product</label>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light" onClick={this.searchList.bind(this)}>
                      Search
                    </button>
                    <button type="reset" className="btn btn-label-secondary waves-effect" onClick={this.resetSearch.bind(this)}>
                      Reset
                    </button>
                  </div>
                </div>
                <div className="card">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 mt-3">{parseInt(this.state.totalPage) > 0 && showRecords(this.state.currentPage, this.state.totalRecords, moduleName)}</div>
                    <div className="col-lg-6 col-md-6 text-end mt-2">
                      <div className="btn-group mx-3">
                        <button type="button" className="btn btn-label-primary dropdown-toggle waves-effect" data-bs-toggle="dropdown" aria-expanded="false">
                          Bulk Update
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <a className="dropdown-item waves-effect" href="/" onClick={this.applyChangeStatus.bind(this, "A")}>
                              Make Active
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item waves-effect" href="/" onClick={this.applyChangeStatus.bind(this, "I")}>
                              Make InActive
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item waves-effect" href="/" onClick={this.applyChangeSequence.bind(this)}>
                              Update Sequence
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item waves-effect" href="/" onClick={this.applyChangePrice.bind(this)}>
                              Update Price
                            </a>
                          </li>
                          
                          <li>
                            <a className="dropdown-item waves-effect" href="/" onClick={this.applyChangeSpecialProduct.bind(this, "productFeatured", "add")}>
                              Add Featured Dishes
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item waves-effect" href="/" onClick={this.applyChangeSpecialProduct.bind(this, "productFeatured", "remove")}>
                              Remove Featured Dishes
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item waves-effect" href="/" onClick={this.applyChangeSpecialProduct.bind(this, "productNewDishes", "add")}>
                              Add New Dishes
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item waves-effect" href="/" onClick={this.applyChangeSpecialProduct.bind(this, "productNewDishes", "remove")}>
                              Remove New Dishes
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className={`${this.state.listdata.length >= 3 ? "table-responsive" : ""} text-nowrap p-1 mt-4`}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>
                            <div className="form-check form-check-inline mt-3">
                              <input className="form-check-input" type="checkbox" id={"chekall"} checked={this.state.checkall} onChange={this.handleChangeCheckAll.bind(this)} />
                              <label className="form-check-label" htmlFor="defaultCheck3">
                                {" "}
                                All{" "}
                              </label>
                            </div>
                          </th>
                          {(checkingPermisson(["catalogs"], "edit") || checkingPermisson(["catalogs"], "delete")) && <th>Actions</th>}
                          <th>Status</th>
                          <th>Sequence{showSortingNew(this.state.sortKey, this.state.sortValue, "productSequence", this.sateValChange)}</th>
                          <th>Price{showSortingNew(this.state.sortKey, this.state.sortValue, "productPrice", this.sateValChange)}</th>
                          <th>Product Name{showSortingNew(this.state.sortKey, this.state.sortValue, "productName", this.sateValChange)}</th>
                          <th>Alias Name{showSortingNew(this.state.sortKey, this.state.sortValue, "productAliasName", this.sateValChange)}</th>
                          
                          <th>Special Product</th>
                          {this.state.allowOutlet === "" && <th>Outlet Name</th>}
                          <th>Type Of Product</th>
                          <th>Category{showSortingNew(this.state.sortKey, this.state.sortValue, "category.categoryName", this.sateValChange)}</th>
                          <th>Sub Category{showSortingNew(this.state.sortKey, this.state.sortValue, "subcategory.subCategoryName", this.sateValChange)}</th>
                          <th>SKU</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={7} align="center">
                              <div className="spinner-border spinner-border-lg text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            const foundProduct = this.state.productSequenceList.find((pitem) => pitem.productID === item._id);
                            const foundProductPrice = this.state.productPriceList.find((pitem) => pitem.productID === item._id);

                            let stockDetails_ = "";
                            if (this.state.allowOutlet !== "") {
                              const productStock = item.productStock;
                              let productStock_ = [];
                              if (productStock !== "" && productStock !== null) {
                                productStock_ = JSON.parse(productStock);
                              }
                              const stockDetails =
                                productStock_.length > 0
                                  ? productStock_.reduce((acc, curr) => {
                                      if (acc) return acc; // already found
                                      return curr?.outletID === this.state.allowOutlet ? curr : null;
                                    }, null)
                                  : null;
                              stockDetails_ = stockDetails !== null ? stockDetails.outletStatus?.value || item.productStatus : item.productStatus;
                            } else {
                              stockDetails_ = item.productStatus;
                            }
                            return (
                              <tr key={index}>
                                <td>
                                  <div className="form-check ">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`check-${index}`}
                                      onChange={this.selectItem.bind(this, item._id)}
                                      checked={this.state.selectedItem.indexOf(item._id) >= 0 ? true : false}
                                    />
                                    <label className="form-check-label" htmlFor={`check-${index}`}>
                                      {" "}
                                      &nbsp;{" "}
                                    </label>
                                  </div>
                                </td>
                                {(checkingPermisson(["catalogs"], "edit") || checkingPermisson(["catalogs"], "delete")) && (
                                  <td>
                                    <div className="dropdown">
                                      <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                        <i className="mdi mdi-dots-horizontal"></i>
                                      </button>
                                      <div className="dropdown-menu">
                                        {checkingPermisson(["catalogs"], "edit") && (
                                          <a href="/" onClick={this.editItem.bind(this, encodeValue(item._id))} className="dropdown-item">
                                            <i className="mdi mdi-pencil-outline me-1"></i>
                                            Edit
                                          </a>
                                        )}
                                        <a className="dropdown-item" href="/" onClick={this.changeStatus.bind(this, item._id, stockDetails_)}>
                                          <i className="mdi mdi-list-status me-1"></i>
                                          {stockDetails_ === "A" ? "Status Change To Inactive" : "Status Change To Active"}
                                        </a>
                                        {checkingPermisson(["catalogs"], "delete") && (
                                          <a className="dropdown-item" href="/" onClick={this.removeItem.bind(this, encodeValue(item._id))}>
                                            <i className="mdi mdi-trash-can-outline me-1"></i>
                                            Delete
                                          </a>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                )}
                                <td>{showStatus(stockDetails_)}</td>
                                <td className="text-center">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="name"
                                      onChange={this.handleChangeSequence.bind(this, item._id)}
                                      value={foundProduct?.value ?? item.productSequence}
                                    />
                                  </div>
                                </td>
                                <td className="text-center">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="name"
                                      onChange={this.handleChangePrice.bind(this, item._id)}
                                      value={foundProductPrice?.value ?? item.productPrice}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <strong>{item.productName}</strong>
                                </td>
                                <td>{item.productAliasName}</td>
                                
                                <td>
                                  {item?.productFeatured && (
                                    <button type="button" className="btn btn-label-info text-nowrap d-inline-flex position-relative me-2">
                                      Featured Dishes
                                      <span
                                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info text-white"
                                        onClick={this.removeSpecialProduct.bind(this, item._id, "productFeatured")}
                                      >
                                        X
                                      </span>
                                    </button>
                                  )}
                                  {item?.productNewDishes && (
                                    <button type="button" className="btn btn-label-info text-nowrap d-inline-flex position-relative me-2">
                                      New Dishes
                                      <span
                                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info text-white"
                                        onClick={this.removeSpecialProduct.bind(this, item._id, "productNewDishes")}
                                      >
                                        X
                                      </span>
                                    </button>
                                  )}
                                </td>
                                {this.state.allowOutlet === "" && (
                                  <td>
                                    {item.productOutletID !== "" && item.productOutletID !== null && (
                                      <>
                                        <div data-tooltip-id={`my-tooltip${index}`}> {item.productOutletID.length > 30 ? item.productOutletID.substring(0, 30) + "..." : item.productOutletID}</div>
                                        {item.productOutletID.length > 30 && (
                                          <Tooltip id={`my-tooltip${index}`} place="right" clickable render={() => <div>{Parser(item.productOutletID.split(",").join("<br/>"))}</div>} />
                                        )}
                                      </>
                                    )}
                                  </td>
                                )}
                                <td>{this.showProductType(item.productType)}</td>
                                <td>{item.category?.categoryName ?? ""}</td>
                                <td>{item.subcategory?.subCategoryName}</td>
                                <td>{item.productSKU}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={8}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <div className="modal fade" id="productmodal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Import Products</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className=" mb-4">
                  <div className="card-body mt-3">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4">
                          <div className="mb-3">
                            <label htmlFor="formFile" className="form-label">
                              Import Simple Product
                            </label>
                            <input className="form-control" type="file" id="simple_file" name="simple_file" />
                            {this.state.errorFile === true && <span className="error">This field is required</span>}
                          </div>
                          <a href="/files/simple-product.csv" download="simple-product.csv">
                            Download Simple Products Sample File
                          </a>
                        </div>
                      </div>
                      <div className="col-md-6"></div>
                      {/* <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4">
                          <div className="mb-3">
                            <label htmlFor="formFile" className="form-label">
                              Import Combo Product
                            </label>
                            <input
                              className="form-control"
                              type="file"
                              id="combo_file"
                              name="combo_file"
                            />
                            {this.state.errorComobFile === true && (
                              <span className="error">
                                This field is required
                              </span>
                            )}
                          </div>
                          <a
                            href="/files/combo-product.csv"
                            download="combo-product.csv"
                          >
                            Download Combo Products Sample File
                          </a>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-label-secondary" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" className="btn btn-primary" id="import_simple" onClick={this.confirmimportProducts.bind(this, "Simple Product")}>
                  Import Simple Product
                </button>
                {/* <button
                  type="button"
                  className="btn btn-primary"
                  id="import_combo"
                  onClick={this.confirmimportProducts.bind(
                    this,
                    "Combo Product"
                  )}
                >
                  Import Combo Product
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
